// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1flnS","col":"styles_col__2XL-8","actions":"styles_actions__2yRVf","conflict":"styles_conflict__2-qMl"};